import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
var API_URL = 'https://www.google.com/recaptcha/api.js';
var ReCaptcha = /*#__PURE__*/function () {
  function ReCaptcha() {
    _classCallCheck(this, ReCaptcha);
    this.elements = {};
    this.grecaptcha = null;
    this.ready = false;
    this.siteKey = '';
  }
  return _createClass(ReCaptcha, [{
    key: "destroy",
    value: function destroy() {
      if (this.ready) {
        this.ready = false;
        var _document = document,
          head = _document.head;
        var style = this.elements.style;
        var scripts = _toConsumableArray(document.head.querySelectorAll('script')).filter(function (script) {
          return script.src.includes('recaptcha');
        });
        if (scripts.length) {
          scripts.forEach(function (script) {
            return head.removeChild(script);
          });
        }
        if (style && head.contains(style)) {
          head.removeChild(style);
        }
        var badge = document.querySelector('.grecaptcha-badge');
        if (badge) {
          badge.remove();
        }
      }
    }
  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.init();
            case 3:
              if (!('grecaptcha' in window)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", this.grecaptcha.execute(this.siteKey, {
                action: action
              }));
            case 5:
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              throw new Error("ReCaptcha error: Failed to execute ".concat(_context.t0));
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 7]]);
      }));
      function execute(_x) {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "reset",
    value: function reset() {
      var _this$grecaptcha;
      (_this$grecaptcha = this.grecaptcha) === null || _this$grecaptcha === void 0 ? void 0 : _this$grecaptcha.reset();
    }
  }, {
    key: "render",
    value: function render(container, params) {
      var _this$grecaptcha2;
      return (_this$grecaptcha2 = this.grecaptcha) === null || _this$grecaptcha2 === void 0 ? void 0 : _this$grecaptcha2.render(container, _objectSpread({
        sitekey: this.siteKey
      }, params));
    }
  }, {
    key: "init",
    value: function init(siteKey) {
      var _this = this;
      this.siteKey = siteKey !== null && siteKey !== void 0 ? siteKey : this.siteKey;
      if (!this.siteKey) {
        // eslint-disable-next-line no-console
        return console.error('ReCaptcha error: No site key provided');
      }
      if (this.ready) {
        return this.ready;
      }
      this.elements = {
        script: document.createElement('script'),
        style: document.createElement('style')
      };
      var script = this.elements.script;
      if (!script) {
        return;
      }
      script.setAttribute('async', '');
      script.setAttribute('defer', '');
      script.setAttribute('src', "".concat(API_URL, "?hl=ru-Ru"));
      this.ready = new Promise(function (resolve, reject) {
        script.addEventListener('load', function () {
          var _this$grecaptcha3;
          _this.grecaptcha = window.grecaptcha;
          (_this$grecaptcha3 = _this.grecaptcha) === null || _this$grecaptcha3 === void 0 ? void 0 : _this$grecaptcha3.ready(resolve);
        });
        script.addEventListener('error', function () {
          document.head.removeChild(script);
          reject(new Error('Index error: Failed to load script'));
          _this.ready = null;
        });
        document.head.appendChild(script);
      });
      return this.ready;
    }
  }]);
}();
export default defineNuxtPlugin(function () {
  return {
    provide: {
      recaptcha: new ReCaptcha()
    }
  };
});